// Action types for profile and navigation actions
const ACTION_TYPES = {
  WEBLINK: 'WEBLINK',
  BOTTOM_SHEET: 'bottomSheet'
}

export default ACTION_TYPES
